<!-- @format -->
<picture [ngClass]="{ 'image-zoom': isImageGalleryZoomEnabled() && !isVideoThumbnail }">
	@for (pictureSource of pictureSources(); track pictureSource.srcSet) {
		<source
			[media]="pictureSource.media ?? ''"
			[srcset]="pictureSource.srcSet ?? ''"
			[type]="pictureSource.type ?? ''" />
	}
	<ng-content select="[fallback-image]"></ng-content>
</picture>
